<template>
  <v-container grid-list-lg fluid>
    <v-layout row align-center>
      <v-flex shrink>
        <v-btn small rounded text @click.stop.prevent="backToRepairHome">
          <v-icon left>mdi-chevron-left </v-icon>
          <span class="hidden-sm-and-down">Report Dashboard</span>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink class="title text-right">
        Open Repairs
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-select v-if="location" outlined dense :items="locations" v-model="location" label="Select Store" hide-details
          return-object item-text="businessName"></v-select>
        <v-list v-if="location">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium text-capitalize">{{ location.businessName }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ location.address }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-flex>
      <!-- <v-spacer></v-spacer>
      <v-flex xs12 md3>
        <DateTimePicker defaultRange="today" :range="true" :hideTime="true" v-model="dateTime"
          @submit="closeDatePicker" />
      </v-flex> -->
    </v-layout>

    <div v-if="location">
      <v-card outlined>
        <RepairList :location="location" />
      </v-card>

    </div>
    <div v-else>
      <v-layout row wrap justify-center>
        <v-flex shrink>
          <v-card width="350" class="mt-5" outlined>
            <v-card-text class="text-center">
              <v-chip label>Location is not selected</v-chip>
              <div class="mt-5">Select Location</div>
              <v-select outlined dense :items="locations" v-model="location" label="Select Store" hide-details
                return-object item-text="businessName"></v-select>
            </v-card-text>

          </v-card>
        </v-flex>
      </v-layout>
    </div>



  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateTimePicker from '@/components/DateTimePicker.vue'
// import reportService from '@/pages/Report/service.js'
import RepairList from '@/pages/Report/components/Repair/RepairList.vue'

export default {
  name: 'repair-view-list',
  data() {
    return {
      search: '',
      loading: false,
      selectedDate: null,
      dateTime: {
        start: null,
        end: null,
      },
      location: null,
    }
  },
  watch: {
    location(val) {
      this.setSelectedLocation(val)
    }
  },
  computed: {
    ...mapGetters('location', ['locations']),
    ...mapGetters('report', ['batchList', 'selectedLocation'])
  },
  components: {
    DateTimePicker,
    RepairList,
  },
  created() {
    if (this.$route.params.location) {
      this.location = this.$route.params.location
    } else {
      if (this.selectedLocation) {
        this.location = this.selectedLocation
      }
    }
  },
  methods: {
    ...mapActions('report', ['setSelectedLocation']),
    backToRepairHome() {
      this.$router.push({ name: 'report-dashboard' });
    },

  }
}
</script>

<style scoped>
</style>